import { toast as sonner } from '@agnes/ui';

/** Substitui a StoreNotify (Pinia). API mínima usada pelas stores/axios. */
export const notify = {
  success(message: string) {
    sonner.success(message);
  },
  error(message: string) {
    sonner.error(message);
  },
  info(message: string) {
    sonner.info(message);
  },
  warning(message: string) {
    sonner.warning(message);
  },
};
